<div class="panel">
    <h3>Parcelas</h3>
    <p *ngIf="proposta.taxaCliente.parcelaMax > 0">Máximo: {{proposta.taxaCliente.parcelaMax || 0 | currency:'BRL':'symbol':'1.2-2'}}</p>
    <div class="row quotas">
            <ng-container *ngFor="let parcela of parcelasSimuladas">
            <div class="col-ths"
                [ngClass]="{
                    'col-xs-6ths': parcelasSimuladas.length > 5,
                    'col-xs-5ths': parcelasSimuladas.length <= 5
                }"
                *ngIf="parcela.periodicidadePagamento === 1">
                
                <input type="radio"
                    name="radioParcelas"
                    [id]="parcela.quantidade"
                    [value]="parcela.quantidade"
                    (change)="onSelectParcela(parcela)"
                    [checked]="parcela.quantidade === simulacao.parcelas"
                    [disabled]="!parcela.exibir">

                <label [for]="parcela.quantidade">
                <span *ngIf="parcela.exibir">
                    {{ parcela.quantidade }}x<br>
                    {{ parcela.valor | currency:'BRL':'symbol':'1.2-2' }}
                </span>
                </label>
            </div>
        </ng-container>
    </div>
</div>

<div class="panel">
    <h3>Primeira Parcela</h3>
    <p class="border">{{simulacao.primeiraParcela * 1000 | date: 'dd/MM/yyyy'}}</p>
    <calendar [titleButton]="'alterar'" [titleCalendar]="'Data para pagamento'" [startDate]="parcelaSelecionada?.dataCarenciaMinima" [endDate]="parcelaSelecionada?.dataCarenciaMaxima" [dateSelected]="simulacao.primeiraParcela" (dateSelectedChange)="onChangePrimeiraParcela($event)"></calendar>
</div>
